import {getCookie, setCookie} from 'typescript-cookie';
import { environment } from "../environments/environment";

export class _i18n {

  private getRemoteHostURL() {
    return `${environment.apiBaseUrl}/constants/i18n`;
  }

  lang: string;
  trTable: any;

  constructor(lang: string) {
    this.lang = lang;
  }

  public async init() {
    return this.maybeLoad();
  }

  public async maybeLoad() {

    //Clear cache if server is in dev mode
    await fetch(`${environment.internalUrl}/devClearCache`);

    //Load from cache by default while we are possibly loading from server
    this.loadFromCache(null);

    return new Promise<void>((resolve, reject) => {
      fetch(this.getRemoteHostURL() + '/hash')
        .then(res => res.text())
        .then(async (hash) => {
          //console.log("hash=" + hash+", cookie=" + getCookie(this.getCookieName(true)));
          if (this.trTable==null || hash != getCookie(this.getCookieName(true))) {
            await this.loadFromRemote(hash);
          } else {
            // Cache is already loaded
            // this.loadFromCache(hash);
          }

          resolve();
        })
        .catch(err => reject())
      }
    )
  }

  private loadFromRemote(hash: string) {
    console.log("Loading i18n from remote");

    return new Promise<void>((resolve, reject) => {
      fetch(this.getRemoteHostURL())
        .then(res => res.text())
        .then(res => {
          this.trTable = JSON.parse(res);
          this.updateGlobal();
          localStorage.setItem(this.getCookieName(true), hash);
          setCookie(this.getCookieName(true), hash);
          localStorage.setItem(this.getCookieName(false), res);
          resolve();
        })
        .catch(err => reject())
    })
  }

  private loadFromCache(hash: string | null) {
    console.log("Loading i18n from cache");
    let tmp = localStorage.getItem(this.getCookieName(false));
    if (tmp != null) {
      this.trTable = JSON.parse(tmp);
      this.updateGlobal();
    }
  }
  private updateGlobal(){
    let that=this;
    (window as any).i18n={lang:this.lang};
    Object.keys(this.trTable).forEach( entry=>{
      let translation=this.trTable[entry];
      let argCount=0;
      let matcher= translation.matchAll('{.*?}');
      while(!matcher.next().done) argCount++;

      if(argCount==0)
        (window as any).i18n[entry]=translation;
      else
        (window as any).i18n[entry]=function(...params){
          return that.tr(entry,... params);
        }


    });
    eval('let i18n=window.i18n;');

  }


  private getCookieName(hash: boolean) {
    return "i18n." + this.lang;
  }

  public tr(...args: any[]): string {
    let str = <string>(this.trTable[args[ 0 ]]);
    if (str == undefined)
      return args[ 0 ];

    for (let i = 1; i < args.length; i++) {
      str = str.replace(/{.*?}/, args[ i ]);
    }
    return str;
  }


  public async update() {
    return new Promise<void>((resolve, reject) => {
      fetch(this.getRemoteHostURL() + '/hash')
        .then(res => res.text())
        .then(async (hash) => {
            await this.loadFromRemote(hash);
            resolve();
        })
    })
  }

}

export const i18n: _i18n = new _i18n("ru");

